import PropTypes from 'prop-types';
import { useProperty, useTranslation } from '@eti/providers';
import {
  PAYMENT,
  SEAT_MAP,
  SELECT_FLIGHT,
  TRAVELER_DETAILS,
  VERIFICATION,
} from '../../constants/bookingFlowSteps';
import StepIndicatorWrapper from './components/StepIndicatorWrapper';
import Step from './components/Step';

const BookingFlowStepIndicator = ({ currentStep, isSeatMapProvided }) => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const showSeatMapStep =
    JSON.parse(sessionStorage.getItem('showSeatMapStep')) || isSeatMapProvided;

  return p('IbeClient.DisplayProgressSteps.Enabled') ? (
    <StepIndicatorWrapper currentStep={currentStep}>
      <Step label={t('StepIndicator.SelectFlight.Label')} stepKey={SELECT_FLIGHT} />
      <Step label={t('StepIndicator.PassengerInfo.Label')} stepKey={TRAVELER_DETAILS} />
      {showSeatMapStep && (
        <Step label={t('StepIndicator.SeatSelection.Label')} stepKey={SEAT_MAP} />
      )}
      {p('IbeClient.TravelerDetails.Modal') === 'REVIEW' && (
        <Step label={t('StepIndicator.VerificationStep.Label')} stepKey={VERIFICATION} />
      )}
      <Step label={t('StepIndicator.Payment.Label')} stepKey={PAYMENT} />
    </StepIndicatorWrapper>
  ) : null;
};

BookingFlowStepIndicator.propTypes = {
  currentStep: PropTypes.string,
  isSeatMapProvided: PropTypes.bool,
};

export default BookingFlowStepIndicator;
